import { createApi } from '@reduxjs/toolkit/query/react';

import { CreateRecentSearchPayload, RecentSearchResponse } from '@/types/Algolia';
import { ResponseError } from '@/types/Error';
import { SuccessResponse } from '@/types/Success';

import { generateBaseQuseryWithReAuth } from '../baseQueryReauth';

const contentTypes = {
  applicationJson: 'application/json',
  rawContentType: 'text/plain',
};

export const recentSearchApi = createApi({
  reducerPath: 'recentSearchApi',
  keepUnusedDataFor: 300,
  baseQuery: generateBaseQuseryWithReAuth({ basePath: 'Shopping' }),
  tagTypes: ['GetRecemtSearches'],
  endpoints: builder => ({
    getRecentSearches: builder.query<SuccessResponse<RecentSearchResponse>, void>({
      query: payload => ({
        url: `/GetAlgoliaRecentItemSearches`,
        method: 'GET',
        headers: {
          'Content-Type': contentTypes.rawContentType,
        },
      }),
      transformResponse: (response: SuccessResponse<RecentSearchResponse>) => response,
      transformErrorResponse: response => response as ResponseError,
      providesTags: ['GetRecemtSearches'],
    }),
    createRecentSearch: builder.mutation<SuccessResponse<string>, CreateRecentSearchPayload>({
      query: payload => ({
        url: `/CreateAlgoliaRecentItemSearches`,
        method: 'POST',
        body: payload,
        headers: {
          'Content-Type': contentTypes.applicationJson,
        },
      }),
      transformResponse: (response: SuccessResponse<string>) => response,
      transformErrorResponse: response => response as ResponseError,
      invalidatesTags: ['GetRecemtSearches'],
    }),

    deleteRecentSearch: builder.mutation<void, string>({
      query: payload => ({
        url: `/DeleteAlgoliaRecentItemSearch?searchKey=${payload}`,
        method: 'GET',
      }),
      transformResponse: (response: void) => response,
      transformErrorResponse: response => response as ResponseError,
      invalidatesTags: ['GetRecemtSearches'],
    }),
  }),
});

export const { useGetRecentSearchesQuery, useCreateRecentSearchMutation, useDeleteRecentSearchMutation } =
  recentSearchApi;
